import { useState } from "react";
import { hrEmployerApi } from "@/lib/api/hr";
import { Button } from "@/components/ui/button";
import { DataTable, Page, Panel } from "@/components/shell/page";

const KINDS = [
  ["employees", "Employees"],
  ["leave", "Leave"],
  ["hours", "Hours"],
  ["tasks", "Tasks"],
  ["performance", "Performance"],
  ["awards", "Awards"],
] as const;

export default function EmployerReportsPage() {
  const [kind, setKind] = useState<(typeof KINDS)[number][0]>("employees");
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);
  const [loaded, setLoaded] = useState(false);

  return (
    <Page title="Reports" description="Pick a report. Rows come from the underlying records.">
      <div className="flex flex-wrap gap-2">
        {KINDS.map(([value, label]) => (
          <Button
            key={value}
            variant={kind === value ? "default" : "outline"}
            onClick={async () => {
              setKind(value);
              const result = await hrEmployerApi.reports(value);
              setRows(Array.isArray(result) ? result : []);
              setLoaded(true);
            }}
          >
            {label}
          </Button>
        ))}
      </div>
      <Panel title={KINDS.find(([value]) => value === kind)?.[1] ?? "Report"}>
        {loaded ? <DataTable rows={rows} /> : <p className="text-sm text-muted-foreground">Choose a report above.</p>}
      </Panel>
    </Page>
  );
}
